import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useToast } from "../components/ui/use-toast";
import { fetch } from "./fetch";

type ChangeYachtResult = {
  success: boolean;
  unchanged: boolean;
  yacht: { id: string; name: string };
  previousYacht: { id: string; name: string } | null;
};

/** Re-point a booking at a different yacht (workspace Phase B). Refetches every
 *  active query afterwards — amenities, operator, pricing views all key off the
 *  yacht, so a targeted invalidation list would just drift. */
export const useBookingYachtMutation = (bookingId: string) => {
  const queryClient = useQueryClient();
  const { toast } = useToast();

  return useMutation({
    mutationFn: (yachtId: string) => fetch<ChangeYachtResult>(`/api/bookings/${bookingId}/yacht`, "PATCH", { yachtId }),
    onSuccess: (res) => {
      toast({
        title: res.unchanged ? "No change" : "Yacht changed",
        description: res.unchanged
          ? `The booking is already on ${res.yacht.name}.`
          : `Booking moved to ${res.yacht.name}. Review pricing and extras — they were carried over from ${res.previousYacht?.name ?? "the previous yacht"}.`,
      });
      queryClient.invalidateQueries();
    },
    onError: (error: any) => {
      toast({ title: "Error", description: error.message || "Failed to change yacht.", variant: "destructive" });
    },
  });
};
